"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const material_1 = require("@angular/material");
const idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
const idm_um_client_js_1 = require("@synisys/idm-um-client-js");
const Observable_1 = require("rxjs/Observable");
const operators_1 = require("rxjs/operators");
const Subject_1 = require("rxjs/Subject");
const dialog_config_helper_1 = require("../../utilities/dialog-config-helper");
require("./comments.component.scss");
const confirm_dialog_component_1 = require("./dialogs/confirm-dialog/confirm-dialog.component");
const comment_model_1 = require("./model/comment.model");
const resource_type_enum_1 = require("./model/resource-type.enum");
const comments_service_1 = require("./service/comments.service");
require("quill-mention");
const idm_authorization_client_js_1 = require("@synisys/idm-authorization-client-js");
const constants_1 = require("../../utilities/constants");
let CommentsComponent = class CommentsComponent {
    constructor(userService, commentsService, currentLanguageProvider, authorizationService, eventBase, sessionDataProvider, dialog) {
        this.userService = userService;
        this.commentsService = commentsService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.authorizationService = authorizationService;
        this.eventBase = eventBase;
        this.sessionDataProvider = sessionDataProvider;
        this.dialog = dialog;
        this.comments = [];
        this.taggedUsers = new Set();
        this.isReady = false;
        this.isEdit = false;
        this.maxLength = 1000;
        this.quillConfig = null;
        this.hasAddPermission = false;
        this.hasManagePermission = false;
        this.destroy$ = new Subject_1.Subject();
        this.timeout = undefined;
    }
    ngOnChanges(changes) {
        if (changes["resourceId"] && !changes["resourceId"].isFirstChange() ||
            changes["resourceTypeId"] && !changes["resourceTypeId"].isFirstChange()) {
            this.clearState();
            this.loadComments();
        }
    }
    ngOnInit() {
        this.initQuillConfig();
        Observable_1.Observable.combineLatest(this.currentLanguageProvider.getCurrentLanguage(), this.sessionDataProvider.getCurrentUserData(), this.loadComments())
            .pipe(operators_1.switchMap(([currentLanguage, currentUserData, commentsTree]) => {
            this.currentUserId = currentUserData.userId;
            this.comments = commentsTree;
            this.currentLanguageId = currentLanguage.id;
            return this.userService.getById(this.currentUserId);
        }), operators_1.switchMap((user) => {
            return Observable_1.Observable.zip(this.userService.getByCriteria({
                pagingCriteria: null,
                sortingCriteria: null,
                searchCriteria: null,
                organizationId: user.organizationId,
                groupId: null,
                currentUserId: this.currentUserId,
                statusId: null
            }), this.loadUserPermissions(this.currentUserId));
        }), operators_1.takeUntil(this.destroy$))
            .subscribe(([users, permissions]) => {
            if (users && users.data) {
                this.users = users.data.map((userDto) => {
                    return {
                        id: userDto.id,
                        value: userDto.firstName + " " + userDto.lastName
                    };
                });
                this.userNamesMap = new Map();
                this.users.forEach((user) => {
                    this.userNamesMap.set(user.id, user.value);
                });
            }
            if (permissions) {
                this.hasAddPermission = permissions[0] && permissions[0].access === idm_authorization_client_js_1.Access.FULL;
                this.hasManagePermission = permissions[1] && permissions[1].access === idm_authorization_client_js_1.Access.FULL;
            }
            setTimeout(() => {
                this.isReady = true;
            }, 1000);
        }, (err) => {
            console.error(err);
        });
    }
    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }
    clearState() {
        this.replyToComment = null;
        this.comments = [];
        this.taggedUsers = new Set();
        this.newMessage = "";
        this.newMessageLength = 0;
        this.isReady = false;
    }
    loadMoreData() {
        // TODO when lazy loading needed
    }
    loadComments() {
        if (this.resourceId && this.resourceTypeId) {
            return this.commentsService.loadComments(this.resourceTypeId, this.resourceId)
                .pipe(operators_1.map((comments) => {
                const commentsTree = [];
                commentsTree.push(...comments.filter((com) => !com.parentId));
                commentsTree.forEach((parent) => {
                    parent.children = comments.filter((com) => com.parentId === parent.id) || [];
                });
                return commentsTree;
            }), operators_1.catchError((err) => {
                console.error(err);
                return [];
            }));
        }
    }
    onCommentEdit() {
        this.isEdit = true;
        this.newMessage = this.commentToDoAction.messageText;
        this.replyToComment = null;
    }
    onCommentDelete() {
        this.dialog.open(confirm_dialog_component_1.ConfirmDialogComponent, dialog_config_helper_1.DialogConfigHelper.getConfirmationDialogConfig("ui_comment_control.confirm", "ui_comment_control.confirm_comment_deletion"))
            .afterClosed()
            .pipe(operators_1.filter((confirmed) => confirmed), operators_1.switchMap(() => {
            return this.commentsService.deleteComment(this.commentToDoAction.id);
        }), operators_1.takeUntil(this.destroy$))
            .subscribe((deletedCommentId) => {
            this.comments = this.comments.filter((comment) => {
                if (comment.id !== deletedCommentId) {
                    comment.children = comment.children.filter((child) => child.id !== deletedCommentId);
                    return true;
                }
                else {
                    return false;
                }
            });
            this.exitEditing();
        }, (err) => console.error(err));
    }
    exitEditing() {
        this.isEdit = false;
        this.commentToDoAction = null;
        this.newMessage = "";
        this.newMessageLength = 0;
    }
    editComment() {
        if (this.newMessageLength && this.newMessageLength <= this.maxLength) {
            this.updateTaggedListBeforeSave();
            this.commentToDoAction.messageText = this.newMessage;
            this.commentToDoAction.taggedUsers = this.taggedUsers ? Array.from(this.taggedUsers) : [];
            this.commentsService.editComment(this.commentToDoAction)
                .pipe(operators_1.takeUntil(this.destroy$))
                .subscribe((editedComment) => {
                this.newMessage = "";
                this.newMessageLength = 0;
                this.commentToDoAction = null;
                this.taggedUsers = new Set();
                this.isEdit = false;
            }, (err) => {
                console.error(err);
            });
        }
    }
    setTextLength() {
        const div = document.createElement('div');
        div.innerHTML = this.newMessage || "";
        this.newMessageLength = div.innerText && div.innerText.length;
    }
    ;
    createComment() {
        if (this.newMessageLength && this.newMessageLength <= this.maxLength) {
            this.updateTaggedListBeforeSave();
            const comment = new comment_model_1.CommentModel(this.replyToComment ? this.replyToComment.id : null, null, this.newMessage, null, null, null, this.resourceTypeId, this.resourceId, this.taggedUsers ? Array.from(this.taggedUsers) : []);
            this.commentsService.addComment(comment)
                .pipe(operators_1.takeUntil(this.destroy$))
                .subscribe((createdComment) => {
                if (this.replyToComment) {
                    this.comments.forEach((parent) => {
                        if (parent.id === this.replyToComment.id) {
                            parent.children.push(createdComment);
                        }
                    });
                }
                else {
                    this.comments.push(createdComment);
                }
                this.newMessage = "";
                this.newMessageLength = 0;
                this.replyToComment = null;
                this.taggedUsers = new Set();
            }, (err) => { console.error(err); });
        }
    }
    replyTo(comment) {
        this.isEdit = false;
        this.commentToDoAction = null;
        this.commentParentToDoAction = null;
        this.replyToComment = comment;
    }
    closeComments() {
        this.eventBase.publish("comment-drawer-state-change", {});
    }
    updateTaggedListBeforeSave() {
        this.taggedUsers && (this.taggedUsers = new Set([...this.taggedUsers].filter((userId) => {
            const idAttribute = `data-id="${userId}"`;
            return this.newMessage.indexOf(idAttribute) > -1;
        })));
    }
    onContentChanged(editor) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => this.setTextLength(), 150);
    }
    initQuillConfig() {
        this.quillConfig = {
            toolbar: null,
            mention: {
                allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
                mentionDenotationChars: ["@"],
                source: (searchTerm, renderList, mentionChar) => {
                    let values = this.users;
                    if (searchTerm.length === 0) {
                        renderList(values, searchTerm);
                    }
                    else {
                        const matches = [];
                        for (var i = 0; i < values.length; i++)
                            if (~values[i].value.toLowerCase().indexOf(searchTerm.toLowerCase()))
                                matches.push(values[i]);
                        renderList(matches, searchTerm);
                    }
                },
                onSelect: (item, insertItem) => {
                    insertItem(item);
                    this.taggedUsers.add(+item.id);
                }
            },
            keyboard: {
                bindings: {
                    enter: {
                        key: 13,
                        handler: (range, context) => {
                            console.log("enter");
                            return true;
                        }
                    }
                }
            }
        };
    }
    loadUserPermissions(userId) {
        return Observable_1.Observable.combineLatest(this.authorizationService.getPermissionAccessValue(userId, constants_1.ADD_COMMENT_PERMISSION_KEY), this.authorizationService.getPermissionAccessValue(userId, constants_1.EDIT_DELETE_COMMENT_PERMISSION_KEY));
    }
};
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], CommentsComponent.prototype, "resourceId", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], CommentsComponent.prototype, "resourceTypeId", void 0);
CommentsComponent = __decorate([
    core_1.Component({
        selector: "sis-comments",
        template: require('./comments.component.html')
    }),
    __metadata("design:paramtypes", [idm_um_client_js_1.UserService, comments_service_1.CommentsService,
        idm_session_data_provider_api_js_1.CurrentLanguageProvider,
        idm_authorization_client_js_1.AuthorizationService,
        idm_session_data_provider_api_js_1.EventBase, idm_session_data_provider_api_js_1.SessionDataProvider, material_1.MatDialog])
], CommentsComponent);
exports.CommentsComponent = CommentsComponent;
//# sourceMappingURL=comments.component.js.map